// extracted by mini-css-extract-plugin
export var centerText = "_hz-8";
export var container = "_hz-0";
export var doughnutContainer = "_hz-7";
export var legend = "_hz-a";
export var legendItemColorDisplay = "_hz-b";
export var legendItemLabel = "_hz-d";
export var legendItemValue = "_hz-c";
export var lg = "_hz-5";
export var maxWidth = "_hz-9";
export var md = "_hz-4";
export var responsive = "_hz-6";
export var sm = "_hz-3";
export var xs = "_hz-2";
export var xxs = "_hz-1";